'use client'
import { useState } from 'react'

export const useCopy = (defaultMessage?: string) => {
  const [message, setMessage] = useState<string | null>(null)
  const copy = (text: string) => {
    navigator.clipboard.writeText(text)
    setMessage(defaultMessage || '')
    setTimeout(() => {
      setMessage(null)
    }, 1000)
  }

  return { copy, message }
}
